import React from 'react';
import { TableHead } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS } from 'utils/constants/dashboard';

type ProjectDrillDownTableHeaderProps = {
  handleSort: (column: string) => void;
};

const ProjectDrillDownTableHeader: React.FC<
  ProjectDrillDownTableHeaderProps
> = ({ handleSort }) => {
  const headCells = [
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT_NUMBER,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_NUMBER'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TITLE,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.TITLE'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT_STATUS,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_STATUS'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT_PRIORITY,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_PRIORITY'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT_OWNER,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_OWNER'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT_HEALTH,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_HEALTH'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.BUSINEES_UNITS,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.BUSINEES_UNIT'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TOTAL_DEMAND_HOURS,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.DEMAND_EST_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.CATEGORY_NAME,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_CATEGORY'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROGRAMS,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROGRAMS'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.START_DATE,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.START_DATE'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName:
        PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TARGET_COMPLETION_DATE,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.TARGET_COMPLETION_DATE'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.COMPLETION_DATE,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.ACTUAL_COMPLETION_DATE'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.RESOURCING_TYPE,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.RESOURCING_TYPE'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROCESS_NAME,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROCESS_NAME'
      ),
    },
    {
      'data-cy': 't-header__Project',
      columnName: PROJECT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.STAGE_NAME,
      content: intl.get(
        'DASHBOARDS_PROJECT_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_STAGE'
      ),
    },
  ];

  return (
    <TableHead stickyHeader handleSort={handleSort} headCells={headCells} />
  );
};

export default ProjectDrillDownTableHeader;
